import { Trans, useTranslation } from 'react-i18next';
import { ErrorWarningtraiangle } from '../../assets/icons';
import { IconSize } from '../../constant/IconSize.constant';
import { SUPPORT_EMAIL } from '../../constant/Text.constant';
import { ColorType, getHexColorByType, Icon, Label, LabelType } from '../_ui';

const LicenseExpiredWarningComponent = () => {
  const { t } = useTranslation();
  const labelText = (
    <Trans i18nKey='license_expired_warning_msg_2'>
      <a
        target='_blank'
        href={`mailto:${SUPPORT_EMAIL}`}
        rel='noreferrer'
        className={LabelType.LABEL_S_MEDIUM}
        style={{ color: getHexColorByType(ColorType.DENIM) }}
      >
        This text will be replaced by actual link text during translation
      </a>
    </Trans>
  );
  return (
    <div className='w-full flex p-5 gap-3 rounded-lg bg-warning_light border-warning2 border-2'>
      <Icon src={ErrorWarningtraiangle} size={IconSize.SIZE_24x24} color={ColorType.WARNING} />
      <div className='flex flex-col gap-2'>
        <Label
          text={t('license_expired_warning')}
          type={LabelType.LABEL_M}
          color={ColorType.BLACK}
        />
        <Label
          text={t('license_expired_warning_msg_1')}
          type={LabelType.BODY3}
          color={ColorType.GREY6}
        />

        <Label text={labelText} type={LabelType.BODY3} color={ColorType.GREY6} />
      </div>
    </div>
  );
};

LicenseExpiredWarningComponent.displayName = 'LicenseExpiredWarningComponent';

export default LicenseExpiredWarningComponent;
